import axios from "axios";
import {
  GRID_MONITORING_API,
  SIMULATION_URLS,
} from "../../config/default.config";
import {
  IAlarmsPayload,
  IGetAllAlarmsPayload,
} from "../../components/alarm.list.component/alarm.interface";

const getAlarmInfo = async () => {
  const token =
    "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJaX0x1THNyR0dlQkMzVV9DQk1IU3Q2a2VtM21JVHFlUTU5WDcyUGt1SDVrIn0.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.EFL_y9Is9NeO--l-ZoE7eK3POmW0tJYrbfVp10swphWtvdsRDbiAYEfM85RoNO5BWxcq3sv-YQqSLD2cO1oogyBwTrnuKctpfZRp7ZhlUZtN0YZYtfQbwB9ovxKHxilcsrvYko_Ae9h2m6rrwEPjUaej4pvi5M7aX6KHbsaiqINkEPNwGWn8TzBYWJjojnsPbUsD5aPj1fTW0eWJWC8HT23z1Z8zNFTpdYwnzUAbtRZWSCPzLyKWkxDpvPfSwhcMxbczH-Xt4p2LSI3pj00bYS4ixxtFdS9H1lAw7rT9lOIqvZkl2UHCOQOrrQHGYEkaZoRYCuBjdVHWoTkAeirCtQ";
  const response = await axios.get("url");
  const dummyResponse = [
    {
      alarm_title: "Alarm 1",
      dateAndTime: 1634721900000,
      equipment: "Equipment 1",
      substation: "Substation 1",
      vl: "VL 1",
      bay: "Bay 1",
    },
    {
      alarm_title: "Alarm 2",
      dateAndTime: 1634722900000,
      equipment: "Equipment 2",
      substation: "Substation 2",
      vl: "VL 2",
      bay: "Bay 2",
    },
    {
      alarm_title: "Alarm 3",
      dateAndTime: 1634722900000,
      equipment: "Equipment 3",
      substation: "Substation 3",
      vl: "VL 3",
      bay: "Bay 3",
    },
    {
      alarm_title: "Alarm 4",
      dateAndTime: 1634722900000,
      equipment: "Equipment 4",
      substation: "Substation 4",
      vl: "VL 4",
      bay: "Bay 4",
    },
    {
      alarm_title: "Alarm 5",
      dateAndTime: 1634722900000,
      equipment: "Equipment 5",
      substation: "Substation 5",
      vl: "VL 5",
      bay: "Bay 5",
    },
  ];
  return dummyResponse;
};

const getCustomerAlarmInfo = async () => {
  const token =
    "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJaX0x1THNyR0dlQkMzVV9DQk1IU3Q2a2VtM21JVHFlUTU5WDcyUGt1SDVrIn0.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.EFL_y9Is9NeO--l-ZoE7eK3POmW0tJYrbfVp10swphWtvdsRDbiAYEfM85RoNO5BWxcq3sv-YQqSLD2cO1oogyBwTrnuKctpfZRp7ZhlUZtN0YZYtfQbwB9ovxKHxilcsrvYko_Ae9h2m6rrwEPjUaej4pvi5M7aX6KHbsaiqINkEPNwGWn8TzBYWJjojnsPbUsD5aPj1fTW0eWJWC8HT23z1Z8zNFTpdYwnzUAbtRZWSCPzLyKWkxDpvPfSwhcMxbczH-Xt4p2LSI3pj00bYS4ixxtFdS9H1lAw7rT9lOIqvZkl2UHCOQOrrQHGYEkaZoRYCuBjdVHWoTkAeirCtQ";
  const response = await axios.get("url");
  const dummyResponse = [
    {
      alarm_title: "Alarm 1",
      dateAndTime: 1634721900000,
      equipment: "Equipment 1",
      substation: "Substation 1",
      vl: "VL 1",
      bay: "Bay 1",
    },
    {
      alarm_title: "Alarm 2",
      dateAndTime: 1634722900000,
      equipment: "Equipment 2",
      substation: "Substation 2",
      vl: "VL 2",
      bay: "Bay 2",
    },
    {
      alarm_title: "Alarm 3",
      dateAndTime: 1634722900000,
      equipment: "Equipment 3",
      substation: "Substation 3",
      vl: "VL 3",
      bay: "Bay 3",
    },
    {
      alarm_title: "Alarm 4",
      dateAndTime: 1634722900000,
      equipment: "Equipment 4",
      substation: "Substation 4",
      vl: "VL 4",
      bay: "Bay 4",
    },
    {
      alarm_title: "Alarm 5",
      dateAndTime: 1634722900000,
      equipment: "Equipment 5",
      substation: "Substation 5",
      vl: "VL 5",
      bay: "Bay 5",
    },
  ];
  return dummyResponse;
};
const getSubstationAlarmInfo = async () => {
  const token =
    "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJaX0x1THNyR0dlQkMzVV9DQk1IU3Q2a2VtM21JVHFlUTU5WDcyUGt1SDVrIn0.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.EFL_y9Is9NeO--l-ZoE7eK3POmW0tJYrbfVp10swphWtvdsRDbiAYEfM85RoNO5BWxcq3sv-YQqSLD2cO1oogyBwTrnuKctpfZRp7ZhlUZtN0YZYtfQbwB9ovxKHxilcsrvYko_Ae9h2m6rrwEPjUaej4pvi5M7aX6KHbsaiqINkEPNwGWn8TzBYWJjojnsPbUsD5aPj1fTW0eWJWC8HT23z1Z8zNFTpdYwnzUAbtRZWSCPzLyKWkxDpvPfSwhcMxbczH-Xt4p2LSI3pj00bYS4ixxtFdS9H1lAw7rT9lOIqvZkl2UHCOQOrrQHGYEkaZoRYCuBjdVHWoTkAeirCtQ";
  const response = await axios.get("url");
  const dummyResponse = [
    {
      alarm_title: "Alarm 1",
      dateAndTime: 1634721900000,
      equipment: "Equipment 1",
      substation: "Substation 1",
      vl: "VL 1",
      bay: "Bay 1",
    },
    {
      alarm_title: "Alarm 2",
      dateAndTime: 1634722900000,
      equipment: "Equipment 2",
      substation: "Substation 2",
      vl: "VL 2",
      bay: "Bay 2",
    },
    {
      alarm_title: "Alarm 3",
      dateAndTime: 1634722900000,
      equipment: "Equipment 3",
      substation: "Substation 3",
      vl: "VL 3",
      bay: "Bay 3",
    },
    {
      alarm_title: "Alarm 4",
      dateAndTime: 1634722900000,
      equipment: "Equipment 4",
      substation: "Substation 4",
      vl: "VL 4",
      bay: "Bay 4",
    },
    {
      alarm_title: "Alarm 5",
      dateAndTime: 1634722900000,
      equipment: "Equipment 5",
      substation: "Substation 5",
      vl: "VL 5",
      bay: "Bay 5",
    },
  ];
  return dummyResponse;
};
const getTransformerAlarmInfo = async () => {
  const token =
    "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJaX0x1THNyR0dlQkMzVV9DQk1IU3Q2a2VtM21JVHFlUTU5WDcyUGt1SDVrIn0.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.EFL_y9Is9NeO--l-ZoE7eK3POmW0tJYrbfVp10swphWtvdsRDbiAYEfM85RoNO5BWxcq3sv-YQqSLD2cO1oogyBwTrnuKctpfZRp7ZhlUZtN0YZYtfQbwB9ovxKHxilcsrvYko_Ae9h2m6rrwEPjUaej4pvi5M7aX6KHbsaiqINkEPNwGWn8TzBYWJjojnsPbUsD5aPj1fTW0eWJWC8HT23z1Z8zNFTpdYwnzUAbtRZWSCPzLyKWkxDpvPfSwhcMxbczH-Xt4p2LSI3pj00bYS4ixxtFdS9H1lAw7rT9lOIqvZkl2UHCOQOrrQHGYEkaZoRYCuBjdVHWoTkAeirCtQ";
  const response = await axios.get("url");
  const dummyResponse = [
    {
      alarm_title: "Alarm 1",
      dateAndTime: 1634721900000,
      equipment: "Equipment 1",
      substation: "Substation 1",
      vl: "VL 1",
      bay: "Bay 1",
    },
    {
      alarm_title: "Alarm 2",
      dateAndTime: 1634722900000,
      equipment: "Equipment 2",
      substation: "Substation 2",
      vl: "VL 2",
      bay: "Bay 2",
    },
    {
      alarm_title: "Alarm 3",
      dateAndTime: 1634722900000,
      equipment: "Equipment 3",
      substation: "Substation 3",
      vl: "VL 3",
      bay: "Bay 3",
    },
    {
      alarm_title: "Alarm 4",
      dateAndTime: 1634722900000,
      equipment: "Equipment 4",
      substation: "Substation 4",
      vl: "VL 4",
      bay: "Bay 4",
    },
    {
      alarm_title: "Alarm 5",
      dateAndTime: 1634722900000,
      equipment: "Equipment 5",
      substation: "Substation 5",
      vl: "VL 5",
      bay: "Bay 5",
    },
  ];
  return dummyResponse;
};

const getAllAlarms = async (alarmPayload: IGetAllAlarmsPayload) => {
  const response = await axios.post(
    SIMULATION_URLS.GET_ALL_ALARMS,
    alarmPayload
  );
  return response.data;
};

const getAlarms = async (alarmPayload: IAlarmsPayload) => {
  const response = await axios.post(
    GRID_MONITORING_API.GET_ALARMS,
    alarmPayload
  );
  return response.data;
};
export const alarmInfoService = {
  getAlarmInfo,
  getCustomerAlarmInfo,
  getSubstationAlarmInfo,
  getTransformerAlarmInfo,
  getAllAlarms,
  getAlarms,
};
